<template>
  <pt-adult-sell-order class="pt-adult-sell-order__page"></pt-adult-sell-order>
</template>

<script>
import PtAdultSellOrder from 'cps/adult-sell-order/pt-adult-sell-order/withData'
export default {
  name: 'pt-adult-sell-order__view',
  components: {
    'pt-adult-sell-order': PtAdultSellOrder
  }
}
</script>
